import '@polaris/lego/lib/style.css';
// todo 这里不要删，删除后再web端报错
window._g_deflang = 'zh-cn';

// _g_deflang = 'zh-cn';

